export default __webpack_public_path__ + "static/SectionTwo_02_01-b806ea11c87389cdc93b769b0ac3b54a.png";